
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","viewBox":"0 0 13 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.3125 11.0498C0.3125 9.25488 1.76757 7.7998 3.5625 7.7998H8.76249C10.5574 7.7998 12.0125 9.25488 12.0125 11.0498V12.3498C12.0125 12.7088 11.7215 12.9998 11.3625 12.9998C11.0035 12.9998 10.7125 12.7088 10.7125 12.3498V11.0498C10.7125 9.97285 9.83945 9.0998 8.76249 9.0998H3.5625C2.48554 9.0998 1.6125 9.97285 1.6125 11.0498V12.3498C1.6125 12.7088 1.32148 12.9998 0.962499 12.9998C0.603515 12.9998 0.3125 12.7088 0.3125 12.3498V11.0498Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.91211 3.25C2.91211 1.45507 4.36718 0 6.16211 0C7.95703 0 9.4121 1.45507 9.4121 3.25C9.4121 5.04492 7.95703 6.49999 6.16211 6.49999C4.36718 6.49999 2.91211 5.04492 2.91211 3.25ZM6.16211 1.3C5.08515 1.3 4.21211 2.17304 4.21211 3.25C4.21211 4.32695 5.08515 5.2 6.16211 5.2C7.23906 5.2 8.1121 4.32695 8.1121 3.25C8.1121 2.17304 7.23906 1.3 6.16211 1.3Z","fill":"white"}})])
          )
        }
      }
    